import { Section, CodeWrapper, NcaLink } from 'nca-acquiring-theme';
import { springCloudParameterStoreReferenceSnippet, springCloudParameterStoreSnippet, springCloudParameterStoreUsageSnippet } from "../../../../src/snippets/AwsSpringCloudSnippets";
import * as React from 'react';
export default {
  Section,
  CodeWrapper,
  NcaLink,
  springCloudParameterStoreReferenceSnippet,
  springCloudParameterStoreSnippet,
  springCloudParameterStoreUsageSnippet,
  React
};